<template>
  <div>
    <div class="question__item">
      <BaseContent :info="params"></BaseContent>
      <el-form class="question__form">
        <el-form-item class="question__form--item">
          <div class="group__item">
            <el-select class="drop__options" v-model="form.q_option_id" @change="selectChange">
              <el-option
                :value="item.value"
                v-for="(item, index) in options"
                :label="item.label"
                :key="index"
                :disabled="item.o_is_disabled || (optionDisable && item.o_is_required === '0')"></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <ErrMessage
        v-show="errShow"
        :visible="errShow"
        :errTitle="errTitle"
      >
      </ErrMessage>
    </div>
    <check-item
      :check="params.check"
      :form="form"
      v-on="$listeners"
      v-bind="$attrs"
      @upCheck="upCheck"></check-item>
  </div>
</template>
<script>
import ErrMessage from '../../components/errorMessage'
import BaseContent from './baseContent'
import { BASE_TYPE_CHECK_DATA_FUN } from '../constant/index'
import * as CHECK_DATA_FUN from '../constant/method'
import { mixin } from '../constant/mixin'
import CheckItem from './checkItem'
export default {
  name: 'dropSelect',
  props: {
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  mixins: [mixin],
  data () {
    return {
      form: {
        question_text: '',
        q_category: '',
        question_id: '',
        q_option_id: '',
        q_answer_info: '',
        q_remark: '',
        q_is_required: 0,
        o_is_required: 0,
        o_has_input: 0,
        o_is_conflict: 0,
        data_datetime: '',
        is_kaocha: '',
        remark: '',
        q_group_id: '',
        q_number: ''
      },
      info: {},
      options: [],
      errShow: false,
      errTitle: '',
      optionDisable: false,
      required_option_id: '',
      or_relation: ''
    }
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('pick', val)
      },
      deep: true
    }
  },
  components: {
    ErrMessage,
    BaseContent,
    CheckItem
  },
  computed: {
    checkFun () {
      return CHECK_DATA_FUN[BASE_TYPE_CHECK_DATA_FUN[this.form.q_category]]
    }
  },
  methods: {
    selectChange () {
      // this.form.q_option_id = e.value
      // this.form.question_text = e.selectedIndex > 0 ? e[e.selectedIndex].innerText : ''
      console.log('tag', this.form.q_option_id)
      this.setFormOtherData(this.form.q_option_id)
      this.checkData()
    },
    checkData (isSubmit) {
      let checkResult = this.checkFun(this.form, this.params)
      if (checkResult.noData) {
        this.errShow = true
        this.errTitle = checkResult.errTitle
      } else {
        this.errShow = false
        !isSubmit && this.logicalHandler()
      }
    },
    setFormOtherData (id) {
      const key = ['o_is_required', 'o_has_input', 'o_is_conflict']
      let selectOption
      if (!id) {
        return
      }
      this.info.option.forEach(item => {
        if (String(item.o_id) === String(id)) {
          selectOption = item
        }
      })
      key.forEach(item => {
        this.form[item] = selectOption[item]
      })
    },
    upCheck (val) {
      this.form = Object.assign(this.form, val)
    }
  },
  mounted () {
    this.info = { ...this.info, ...this.params }
    Object.keys(this.form).forEach(item => {
      this.form[item] = this.params[item] || ''
      if (item === 'data_datetime') {
        this.form[item] = this.params.check[0] && this.params.check[0].data_datetime
      }
      if (item === 'remark') {
        this.form[item] = this.params.check[0] && this.params.check[0].remark
      }
    })
    this.options = []
    if (!this.params.option) return
    this.params.option.forEach(item => {
      if (item.o_default_selected === 1) {
        this.form.q_option_id = item.o_id
        this.form.question_text = item.o_name
      }
      if (item.o_is_required === '1') {
        this.required_option_id = item.o_id
        this.optionDisable = true
      }
      if (item.o_is_required === '1' && item.o_default_selected === 1) {
        this.or_relation = item.o_id
      }
      // 整理及联起数据结构
      this.options.push({
        label: item.o_name,
        value: item.o_id,
        o_is_disabled: item.o_is_disabled,
        o_is_required: item.o_is_required
      })
    })
    this.form.q_option_id = this.required_option_id ? this.required_option_id : this.form.q_option_id
    if (this.params.relation === 'and') {
      this.form.q_option_id = this.required_option_id ? this.required_option_id : this.form.q_option_id
    } else {
      this.form.q_option_id = this.or_relation
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
